import Button from '@viking-eng/button';
import PropTypes from 'prop-types';

import './UserInfo.scss';
import { FORMS } from 'common/Constants';
import EditName from 'components/EditName/EditNameContainer';
import { prepareHtml } from 'utils/strings';

const UserInfo = ({ b2cUserData, handleActionClicked, isSubmitting, submitErrors, submitFailed }) => {
  const LABELS = {
    EDIT_INFO: 'EDIT INFO',
  };
  const { email, firstName, id, lastName, userType } = b2cUserData;
  const modalData = { email, firstName, id, lastName, userType };
  if (isSubmitting) {
    return null;
  }
  if (submitFailed) {
    return (
      <div className="row search-result-container">
        <div className="col-12 no-result-container">
          <div className={submitErrors.type || 'no-result-text'} dangerouslySetInnerHTML={prepareHtml(submitFailed)} />
        </div>
      </div>
    );
  }
  if (b2cUserData?.email) {
    const getUserInfoColumn = ({ col = 2, label, value }) => (
      <div className={`col-${col}`} key={label}>
        <span className="booking-details-title small-body-copy d-block font-weight-bold">{label}</span>
        <span className="booking-details-value medium-body-copy d-block">{value}</span>
      </div>
    );

    const actionButton = (
      <Button
        appearance="link"
        attributes={{
          'data-dismiss': 'modal',
          'data-target': `#${FORMS.EDIT_NAME}`,
          'data-toggle': 'modal',
          disabled: false,
        }}
        onButtonClick={() => {
          handleActionClicked({
            email,
            firstName,
            id,
            lastName,
            userType,
          });
        }}
      >
        {LABELS.EDIT_INFO}
      </Button>
    );

    const userInfoDataOrdered = Object.freeze([
      { label: 'DISPLAY NAME', value: `${firstName} ${lastName}` },
      { label: 'FIRST NAME', value: firstName },
      { label: 'LAST NAME', value: lastName },
      { label: 'USER TYPE', value: userType },
      { label: '\u00a0', value: actionButton },
    ]);

    return (
      <div>
        <div className="row search-result-container">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <div className="booking-details-title">
                  <span className="booking-details-title medium-body-copy font-weight-bold">Email Address: </span>
                  <span className="medium-body-copy">{email}</span>
                </div>
              </div>
            </div>
            <div className="guest-list">
              <span className="title medium-body-copy d-block">Details</span>
              <div className="row">
                <div className="col-12">
                  <div className="row guest-row pb-3">
                    {userInfoDataOrdered.map((item, idx) =>
                      getUserInfoColumn({ label: item.label, value: item.value, col: idx === 0 ? 4 : 2 })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <EditName
            {...modalData}
            id={FORMS.EDIT_NAME}
            user={{
              email,
              firstName,
              id,
              lastName,
              userType,
            }}
          />
        </div>
      </div>
    );
  }

  return null;
};

UserInfo.propTypes = {
  b2cUserData: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.string,
    lastName: PropTypes.string,
    userType: PropTypes.string,
  }).isRequired,
  handleActionClicked: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  submitErrors: PropTypes.shape({
    type: PropTypes.string,
  }),
  submitFailed: PropTypes.string,
  submitSucceeded: PropTypes.bool.isRequired,
};

UserInfo.defaultProps = {
  submitErrors: {},
  submitFailed: '',
};

export default UserInfo;
